<div class="self-ins-app">
  <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-scale-multiple"></ngx-spinner>
  <app-mobile-navigation *ngIf="isAuthorized" [pageTitle]="currentPageTitle"></app-mobile-navigation>
  <div class="app-content" [class.with-mobile-nav]="isAuthorized" [class.with-policy-dropdown]="isAuthorized && showPolicyDropdown">
    <div class="content-wrapper">
      <router-outlet></router-outlet>
    </div>
  </div>
  <div class="mobile-logo-footer" *ngIf="isAuthorized">
    <img src="../assets/freight-logo.svg" alt="Logo">
  </div>
  <a (click)="logout()" *ngIf="showLogoutButton" [title]="'common.logout' | translate" class="logout hide-mobile">
    <img src="../assets/logout.svg" alt="logout">
  </a>
</div>
